import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { IoClose } from "react-icons/io5"
import "../css/login.css"
import "../css/wa.css"
import { useToast } from "../components/ToastProvider";

const Login = () => {
  const navigate = useNavigate()

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [message, setMessage] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const showToast = useToast();
  

  const handleLogin = async () => {
    setIsSubmitting(true)
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/login`, { email, password })
      const token = response.data.token
      localStorage.setItem("token", token)
      window.location.href = "/";
    } catch (error) {
      setMessage(error.response?.data?.message || "로그인 실패")
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div className="lg-main">
        <h2>로그인</h2>
        <input
          type="email"
          placeholder="이메일"
          value={email}
          className="lg-main-input"
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="비밀번호"
          value={password}
          className="lg-main-input"
          onChange={(e) => setPassword(e.target.value)}
        />

        <div className="lg-error-message">{message}</div>

        <button className="lg-main-button" onClick={handleLogin} disabled={isSubmitting || !email || !password}>
          {isSubmitting ? "처리 중..." : "로그인하기"}
        </button>

        <div className="lg-bottom">
          <a href="/signup">회원가입하기</a>|<a href="/login/find">비밀번호 찾기</a>
        </div>
      </div>
    </div>
  )
}

export default Login

